import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class OpenTracingInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'X-B3-TraceId': this.generateId(16),
        'X-B3-SpanId': this.generateId(8),
      },
    });

    return next.handle(request);
  }

  /**
   * Generates a random B3 identifier of the given length in bytes,
   * returned as a lower-case hex string. B3 TraceIds are 128-bit (16 bytes)
   * and SpanIds are 64-bit (8 bytes).
   */
  private generateId(bytes: number): string {
    let id = '';
    for (let i = 0; i < bytes / 4; i++) {
      id += `00000000${Math.abs((Math.random() * 0xFFFFFFFF) | 0).toString(16)}`.slice(-8);
    }
    return id;
  }
}
